// extracted by mini-css-extract-plugin
export var mylist = "songs-list-module--mylist--qv7dx";
export var icon = "songs-list-module--icon--ZhHbl";